import { Text, Icon, IconStatus, TableBody, TableItem, HStack, VStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { Utils, useBreakpointValue } from '@genial/utils';
import { useNavigation } from '@react-navigation/native';
import { Pressable } from 'native-base';
import React from 'react';

import { SignedInNavigationScreenNavigationProp } from '../../../../../../routes/types';
import { ManagementFeeStatus } from '../../../../../../store/rateManagement/constants';
import { columnWidthsDesktop, columnWidthsTablet } from '../../constants';

import { ItemIcon } from './ItemIcon';

import { SentOrderListItemTypes } from '.';

export const SentOrderListItemDesktop: React.FC<SentOrderListItemTypes.Props> = ({ item }) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();
  const deviceType = useBreakpointValue({ md: 'desktop', sm: 'tablet' });

  const getStatusIcon = () => {
    if (
      item.managementFeeStatusIconNormalized &&
      item.managementFeeStatusIconColorNormalized &&
      item.managementFeeStatusIconSizeNormalized &&
      item.managementFeeStatusIconBackgroundNormalized
    ) {
      return (
        <IconStatus
          icon={item.managementFeeStatusIconNormalized}
          color={item.managementFeeStatusIconColorNormalized}
          testId="header-section-status-icon"
          size={item.managementFeeStatusIconSizeNormalized}
          bgColor={item.managementFeeStatusIconBackgroundNormalized}
        />
      );
    }
  };

  const currentStatus = getStatusIcon();

  return (
    <TableBody testId="table-body" spaceX="inset.sm">
      <TableItem
        align="center"
        width={deviceType === 'desktop' ? columnWidthsDesktop.icon : columnWidthsTablet.icon}
        testId="header-id">
        <ItemIcon isProcessingOrInvalid={item.isProcessing || item.isInvalid} />
      </TableItem>

      <TableItem
        align="start"
        width={deviceType === 'desktop' ? columnWidthsDesktop.sendId : columnWidthsTablet.sendId}
        testId="header-order">
        <VStack py={Spacing['inset.xs']} justifyContent={'space-between'} flex={1}>
          {deviceType === 'tablet' && (
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              paddingBottom={Spacing['inset.nano']}
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              fontWeight={Typography['fontweight.semibold']}
              flex={1}
              textAlign="start">
              ID ORDEM
            </Text>
          )}
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.semibold']}
            fontSize={Utils.Responsive.All({
              phone: Typography['fontsize.xs'],
              tablet: Typography['fontsize.xs'],
              desktop: Typography['fontsize.md'],
            })}
            flex={1}
            textAlign="start">
            {item.managementFeeHashNormalized}
          </Text>
        </VStack>
      </TableItem>

      <TableItem
        align="start"
        width={
          deviceType === 'desktop'
            ? columnWidthsDesktop.monthCompetence
            : columnWidthsTablet.monthCompetence
        }
        testId="header-last-update">
        <VStack py={Spacing['inset.xs']} justifyContent={'space-between'} flex={1}>
          {deviceType === 'tablet' && (
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              paddingBottom={Spacing['inset.nano']}
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              fontWeight={Typography['fontweight.semibold']}
              flex={1}
              textAlign="start">
              Competência
            </Text>
          )}
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Utils.Responsive.All({
              phone: Typography['fontsize.xs'],
              tablet: Typography['fontsize.xs'],
              desktop: Typography['fontsize.md'],
            })}
            flex={1}
            textAlign="start">
            {item.managementFeeMonthNormalized}
          </Text>
        </VStack>
      </TableItem>

      <TableItem
        align="start"
        width={deviceType === 'desktop' ? columnWidthsDesktop.type : columnWidthsTablet.type}
        testId="header-clients">
        <VStack py={Spacing['inset.xs']} justifyContent={'space-between'} flex={1}>
          {deviceType === 'tablet' && (
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              paddingBottom={Spacing['inset.nano']}
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              fontWeight={Typography['fontweight.semibold']}
              flex={1}
              textAlign="start">
              Tipo
            </Text>
          )}
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Utils.Responsive.All({
              phone: Typography['fontsize.xs'],
              tablet: Typography['fontsize.xs'],
              desktop: Typography['fontsize.md'],
            })}
            flex={1}
            textAlign="start">
            {item.managementFeeTypeNormalized}
          </Text>
        </VStack>
      </TableItem>

      <TableItem
        align="start"
        width={
          deviceType === 'desktop'
            ? columnWidthsDesktop.billedCustomers
            : columnWidthsTablet.billedCustomers
        }
        testId="header-assets">
        <VStack justifyContent={'space-between'} flex={1}>
          {deviceType === 'tablet' && (
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              paddingTop={'2px'}
              paddingBottom={'4px'}
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              fontWeight={Typography['fontweight.semibold']}
              flex={1}
              textAlign="start">
              Clientes
            </Text>
          )}
          <HStack flex={1} justifyContent={'center'} alignItems={'center'}>
            <Icon name="Clients" size="xxs" testId="period-icon" color={Color['neutral.medium']} />
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              alignItems={'center'}
              paddingLeft={Spacing['inline.nano']}
              fontWeight={Typography['fontweight.regular']}
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              flex={1}
              textAlign="start">
              {item.totalCustomersNormalized}
            </Text>
          </HStack>
        </VStack>
      </TableItem>

      <TableItem
        align="start"
        width={
          deviceType === 'desktop' ? columnWidthsDesktop.sendDate : columnWidthsTablet.sendDate
        }
        testId="header-total-sent">
        <VStack py={Spacing['inset.xs']} justifyContent={'space-between'} flex={1}>
          {deviceType === 'tablet' && (
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              paddingBottom={Spacing['inset.nano']}
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              fontWeight={Typography['fontweight.semibold']}
              flex={1}
              textAlign="start">
              Data de envio
            </Text>
          )}
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Utils.Responsive.All({
              phone: Typography['fontsize.xs'],
              tablet: Typography['fontsize.xs'],
              desktop: Typography['fontsize.md'],
            })}
            textAlign="start">
            {item.managementFeeSentAtNormalized}
          </Text>
        </VStack>
      </TableItem>

      <TableItem
        align="start"
        width={deviceType === 'desktop' ? columnWidthsDesktop.total : columnWidthsTablet.total}
        testId="header-total-sent">
        <VStack py={Spacing['inset.xs']} justifyContent={'space-between'} flex={1}>
          {deviceType === 'tablet' && (
            <Text
              numberOfLines={1}
              ellipsizeMode="tail"
              paddingBottom={Spacing['inset.nano']}
              fontSize={Utils.Responsive.All({
                phone: Typography['fontsize.xs'],
                tablet: Typography['fontsize.xs'],
                desktop: Typography['fontsize.md'],
              })}
              fontWeight={Typography['fontweight.semibold']}
              flex={1}
              textAlign="start">
              Total a receber
            </Text>
          )}
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Utils.Responsive.All({
              phone: Typography['fontsize.xs'],
              tablet: Typography['fontsize.xs'],
              desktop: Typography['fontsize.md'],
            })}
            flex={1}
            textAlign="start">
            {item.totalNormalized}
          </Text>
        </VStack>
      </TableItem>

      <TableItem
        align="start"
        width={deviceType === 'desktop' ? columnWidthsDesktop.status : columnWidthsTablet.status}
        testId="header-clients">
        <HStack flex={1} maxWidth="108%" justifyContent={'center'} alignItems={'center'}>
          {currentStatus}
          <Text
            pl={Spacing['inline.nano']}
            numberOfLines={1}
            ellipsizeMode="tail"
            fontWeight={Typography['fontweight.regular']}
            fontSize={Utils.Responsive.All({
              phone: Typography['fontsize.xs'],
              tablet: Typography['fontsize.xs'],
              desktop: Typography['fontsize.md'],
            })}
            flex={1}
            textAlign="start">
            {item.managementFeeStatusTextNormalized}
          </Text>
        </HStack>
      </TableItem>

      <TableItem
        align="end"
        width={deviceType === 'desktop' ? columnWidthsDesktop.actions : columnWidthsTablet.actions}
        testId="header-actions">
        <Pressable
          isDisabled={item.isProcessing}
          onPress={() =>
            navigate('RequestDetails', { sentOrderId: item.managementFeeIdNormalized })
          }>
          <HStack alignItems="center">
            {deviceType === 'desktop' && (
              <Text
                numberOfLines={1}
                ellipsizeMode="tail"
                fontWeight={Typography['fontweight.semibold']}
                fontSize={Utils.Responsive.All({
                  phone: Typography['fontsize.xs'],
                  tablet: Typography['fontsize.xs'],
                  desktop: Typography['fontsize.md'],
                })}
                flex={1}
                color={item.isProcessing ? 'neutral.light' : 'brand.tertiary.principal'}
                textAlign="start">
                {item.managementFeeStatusNormalized === ManagementFeeStatus.Processed ||
                item.managementFeeStatusNormalized === ManagementFeeStatus.Created
                  ? 'CONFIRMAR'
                  : 'DETALHES'}
              </Text>
            )}

            <Icon
              name="ChevronRight"
              color={item.isProcessing ? Color['neutral.light'] : Color['brand.tertiary.principal']}
              testId="action-button"
              size="sm"
            />
          </HStack>
        </Pressable>
      </TableItem>
    </TableBody>
  );
};
